import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteMultiple: {
    id: 'frontbucket.branches.branchListActions.deleteMultiple',
    description: 'Dropdown item label for deleting multiple branches',
    defaultMessage: 'Delete multiple',
  },
});
